// export const colors = {
//   gray:        '#4B5563',
//   primary:     '#1D4ED8',
//   primarySoft: '#E0EAFF',
//   accent:      '#22C55E',
//   background:  '#F9FAFB',
//   cardBg:      '#FFFFFF',
//   border:      '#E5E7EB',
// };

// export const theme = {
//   palette: {
//     primary: {
//       main: colors.primary,
//     },
//     secondary: {
//       main: colors.accent,
//     },
//     text: {
//       primary: colors.gray,
//       secondary: colors.primary,
//     },
//     background: {
//       default: colors.background,
//       paper: colors.cardBg,
//     },
//     divider: colors.border,
//   },
//   typography: {
//     fontFamily: 'Inter, Roboto, Arial, sans-serif',
//     button: {
//       textTransform: 'none',
//       fontWeight: 600,
//       letterSpacing: 0.2,
//     },
//   },
// };

import { alpha } from "@mui/material/styles";

export const brandTokens = {
  light: {
    accent: "#f97316",
    accentSoft: "#fff7ed",
    pageBg: "#ffffff",
    surfaceBg: "#f8f8fb",
    cardBg: "#ffffff",
    text: "#0f0f1a",
    textMid: "#4b4b6a",
    textMuted: "#9898b8",
    border: "#e8e8f0",
    borderStrong: "#d4d4e4",
    success: "#15803d",
    warning: "#d97706",
    error: "#dc2626",
    info: "#2563eb",
  },
  dark: {
    accent: "#fb923c",
    accentSoft: "rgba(251,146,60,0.12)",
    pageBg: "#07080f",
    surfaceBg: "#0d1220",
    cardBg: "#0d1220",
    text: "#e8f0fe",
    textMid: "#94a3b8",
    textMuted: "#4b6080",
    border: "rgba(99, 179, 237, 0.10)",
    borderStrong: "rgba(99, 179, 237, 0.22)",
    success: "#86efac",
    warning: "#fbbf24",
    error: "#fca5a5",
    info: "#93c5fd",
  },
};

export const colors = {
  // legacy aliases for older screens
  purple: brandTokens.light.accent,
  purpleDark: brandTokens.dark.accent,
  primary: brandTokens.light.accent,
  primarySoft: brandTokens.light.accentSoft,
  accent: brandTokens.light.accent,

  gray: brandTokens.light.textMid,
  text: brandTokens.light.text,
  textSecondary: brandTokens.light.textMid,
  muted: brandTokens.light.textMuted,

  background: brandTokens.light.pageBg,
  surface: brandTokens.light.surfaceBg,
  cardBg: brandTokens.light.cardBg,

  border: brandTokens.light.border,
  borderStrong: brandTokens.light.borderStrong,

  darkBackground: brandTokens.dark.pageBg,
  darkSurface: brandTokens.dark.surfaceBg,
  darkCardBg: brandTokens.dark.cardBg,
  darkBorder: brandTokens.dark.border,
  darkBorderStrong: brandTokens.dark.borderStrong,
  darkText: brandTokens.dark.text,
  darkTextSecondary: brandTokens.dark.textMid,
  darkMuted: brandTokens.dark.textMuted,

  success: brandTokens.light.success,
  warning: brandTokens.light.warning,
  error: brandTokens.light.error,
  info: brandTokens.light.info,

  white: "#ffffff",
  black: "#0f0f1a",
};

export function getAppTheme(mode = "light") {
  const isDark = mode === "dark";
  const t = isDark ? brandTokens.dark : brandTokens.light;

  return {
    palette: {
      mode,
      primary: {
        main: t.accent,
        contrastText: "#ffffff",
      },
      secondary: {
        main: t.textMid,
      },
      background: {
        default: t.pageBg,
        paper: t.cardBg,
      },
      text: {
        primary: t.text,
        secondary: t.textMid,
      },
      divider: t.border,
      success: {
        main: t.success,
      },
      warning: {
        main: t.warning,
      },
      error: {
        main: t.error,
      },
      info: {
        main: t.info,
      },
    },

    typography: {
      fontFamily: `"Plus Jakarta Sans", "Inter", "Roboto", "Arial", sans-serif`,
      h1: {
        fontWeight: 800,
        letterSpacing: "-0.03em",
        lineHeight: 1.04,
      },
      h2: {
        fontWeight: 800,
        letterSpacing: "-0.03em",
        lineHeight: 1.08,
      },
      h3: {
        fontWeight: 800,
        letterSpacing: "-0.02em",
      },
      h4: {
        fontWeight: 700,
        letterSpacing: "-0.02em",
      },
      h5: {
        fontWeight: 700,
      },
      h6: {
        fontWeight: 700,
      },
      button: {
        textTransform: "none",
        fontWeight: 700,
        letterSpacing: 0,
      },
      body1: {
        lineHeight: 1.75,
      },
      body2: {
        lineHeight: 1.7,
      },
      caption: {
        color: t.textMuted,
      },
    },

    shape: {
      borderRadius: 14,
    },

    components: {
      MuiCssBaseline: {
        styleOverrides: {
          body: {
            backgroundColor: t.pageBg,
            color: t.text,
            fontFamily: `"Plus Jakarta Sans", "Inter", "Roboto", "Arial", sans-serif`,
            transition:
              "background-color 0.25s ease, color 0.25s ease",
          },
          "*": {
            boxSizing: "border-box",
          },
          "*::-webkit-scrollbar": {
            width: "10px",
            height: "10px",
          },
          "*::-webkit-scrollbar-track": {
            background: "transparent",
          },
          "*::-webkit-scrollbar-thumb": {
            background: "rgba(120,120,140,0.45)",
            borderRadius: "999px",
            border: "2px solid transparent",
            backgroundClip: "content-box",
          },
        },
      },

      MuiAppBar: {
        styleOverrides: {
          root: {
            backgroundImage: "none",
          },
        },
      },

      MuiPaper: {
        styleOverrides: {
          root: {
            backgroundImage: "none",
          },
          rounded: {
            borderRadius: 20,
          },
        },
      },

      MuiCard: {
        styleOverrides: {
          root: {
            borderRadius: 20,
            border: `1px solid ${t.border}`,
            backgroundImage: "none",
            boxShadow: isDark
              ? "0 20px 50px rgba(0,0,0,0.28)"
              : "0 20px 50px rgba(15,15,26,0.05)",
          },
        },
      },

      MuiButton: {
        defaultProps: {
          disableElevation: true,
        },
        styleOverrides: {
          root: {
            borderRadius: 12,
            paddingInline: 18,
            paddingBlock: 10,
          },
          containedPrimary: {
            background: t.accent,
            color: "#fff",
            boxShadow: `0 14px 34px ${alpha(t.accent, 0.26)}`,
          },
          outlined: {
            borderColor: t.borderStrong,
          },
        },
      },

      MuiChip: {
        styleOverrides: {
          root: {
            borderRadius: 999,
            fontWeight: 700,
          },
        },
      },

      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            borderRadius: 14,
            backgroundColor: isDark ? "rgba(8,12,24,0.7)" : "#ffffff",
            transition: "all .2s ease",
            "& fieldset": {
              borderColor: t.border,
            },
            "&:hover fieldset": {
              borderColor: t.borderStrong,
            },
            "&.Mui-focused": {
              boxShadow: `0 0 0 4px ${alpha(t.accent, 0.12)}`,
            },
            "&.Mui-focused fieldset": {
              borderColor: t.accent,
            },
          },
          input: {
            color: t.text,
          },
        },
      },

      MuiInputLabel: {
        styleOverrides: {
          root: {
            color: t.textMid,
            fontWeight: 500,
            "&.Mui-focused": {
              color: t.accent,
            },
          },
        },
      },

      MuiFormHelperText: {
        styleOverrides: {
          root: {
            color: t.textMuted,
          },
        },
      },

      MuiDivider: {
        styleOverrides: {
          root: {
            borderColor: t.border,
          },
        },
      },

      MuiSnackbarContent: {
        styleOverrides: {
          root: {
            borderRadius: 12,
          },
        },
      },
    },
  };
}